import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import {CardContainer, Notification, Loading, Badge} from 'components/common/uiKit';
import {NoRecord} from 'components/common/app';

import {LevelApi} from 'services/network/api';

class LevelsTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            courseId: props.courseId,
            data: undefined,
            loading: true
        };
    }

    componentDidMount() {
        const res = this.checkCourseId();
        if (!res) {
            Notification('error', 'WrongData');
            return;
        }

        this.loadData()
    }

    checkCourseId() {
        const {courseId} = this.props;
        if (courseId) {
            this.setState({courseId});
            return true;
        }
        return false;
    }

    loadData() {
        const {courseId} = this.state;
        LevelApi.GetByCourseId(courseId)
            .then(res => {
                if (res && res.status == 200) {
                    const {data} = res;
                    this.setState({data});
                }
            }).finally(() => {
            this.setState({loading: false});
        })
    }

    _applyItemState = (state) => {

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.App.Course.Level.State;

        switch (state.toUpperCase()) {
            case 'ACTIVE':
                return {type: 'primary', text: pageTranslates.Active};
            case 'DONE':
                return {type: 'success', text: pageTranslates.Done};
            case 'PENDING':
                return {type: 'warning', text: pageTranslates.Pending};
            case 'LOCK':
                return {type: 'default', text: pageTranslates.Lock};
        }
    };

    _handleLevelClick = (level) => {
        const {history} = this.props;
        const {id, stateTxt} = level;
        if (stateTxt.toUpperCase() == 'LOCK') {
            Notification('error', 'ShouldCompletePreviousLevels');
            return;
        }

        history.push({
            pathname: `level?id=${id}`,
            //search: `?lessonId=${id}`,
            //state: {...data}
        });
    };

    render() {
        const {data, loading} = this.state;

        if (loading)
            return <Loading/>;

        if (!data || !data.levels || data.levels.length == 0)
            return (<NoRecord message='CourseLevel'/>);

        const {description, levels} = data;

        return (
            <CardContainer>
                <p>
                    {description}
                </p>


                <div className="list-group list-custom-small">
                    {levels.map((item, index) => {
                        const number = index + 1;
                        const {title} = item;
                        const status = this._applyItemState(item.stateTxt);

                        return (
                            <a onClick={this._handleLevelClick.bind(this, item)}>
                                <div className='float-right'>
                                    <i className='rounded-sm shadow-xl bg-primary' style={{fontStyle: 'normal'}}>
                                        {number}
                                    </i>
                                    <span>
                                    {title}
                                </span>
                                </div>
                                <div className='float-left'>
                                    <Badge {...status}/>
                                    <i className="fa fa-angle-left"></i>
                                </div>
                            </a>
                        );
                    })}
                </div>
            </CardContainer>
        );
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(LevelsTab));